import { render, staticRenderFns } from "./activity-guidance.vue?vue&type=template&id=06370186"
import script from "./activity-guidance.vue?vue&type=script&lang=js"
export * from "./activity-guidance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports